<script setup>
import { computed, ref } from "vue";

const ccy = new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK" });

const pricePark = ref(20);
const priceEl = ref(3);
const visitCount = ref(20);
const avgDuration = ref(3);
const avgEnergy = ref(25);
const costEl = ref(0.5);
const gross = computed(() => visitCount.value * (pricePark.value * avgDuration.value + priceEl.value * avgEnergy.value));
const cost = computed(() => visitCount.value * costEl.value * avgEnergy.value);
const zevFee = computed(() => gross.value * 0.15 + visitCount.value * 1);
</script>

<template>
	<b>DINE PRISINNSTILLINGER</b>
	<div class="calc list">
		<div>
			<div>Parkeringspris (kr/time)</div>
			<input v-model="pricePark" type="number">
		</div>
		<div>
			<div>Ladepris (kr/kWh)</div>
			<input v-model="priceEl" type="number" step="0.1">
		</div>
	</div>
	<b>TYPISK BRUK</b>
	<div class="calc list">
		<div>
			<div>Besøk per måned</div>
			<input v-model="visitCount" type="number">
		</div>
		<div>
			<div>Typisk parkeringstid (timer)</div>
			<input v-model="avgDuration" type="number">
		</div>
		<div>
			<div>Typisk energiforbruk (kWh)</div>
			<input v-model="avgEnergy" type="number">
		</div>
	</div>
	<b>DINE KOSTNADER</b>
	<div class="calc list">
		<div>
			<div>Strømpris (kr/kWh)</div>
			<input v-model="costEl" type="number" step="0.1">
		</div>
	</div>
	<b>ESTIMERT FORTJENESTE</b>
	<div class="calc list">
		<div>
			<div>Beregningsgrunnlag</div>
			<div>{{ ccy.format(gross) }}</div>
		</div>
		<div>
			<div>Energiforbruk</div>
			<div>{{ ccy.format(-cost) }}</div>
		</div>
		<div>
			<div>ZEV trekk (15 % + 1 kr/transaksjon)</div>
			<div>{{ ccy.format(-zevFee) }}</div>
		</div>
		<div>
			<b>Fortjeneste</b>
			<b>{{ ccy.format(gross - zevFee - cost) }}</b>
		</div>
	</div>
</template>
